import { Box, Button, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useBaseStore } from '@roc/feature-app-core';
import { SignatureField, SignatureFieldHandle } from '@roc/ui';
import { format } from 'date-fns';
import { observer } from 'mobx-react';
import { WetSignRequiredNotice } from '../wetSign/wetSignRequiredNotice';
import { isTpoWithMersLoan } from '../wetSign/wetSignConstants';

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: 1000,
    margin: 'auto',
    padding: theme.spacing(6),
    backgroundColor: '#fff',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(2),
    boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
    overflow: 'auto',
    position: 'relative',
  },
  title: {
    fontWeight: 700,
    fontSize: '1.6rem',
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  titleLeft: {
    fontWeight: 700,
    fontSize: '1.6rem',
    marginBottom: theme.spacing(4),
    textAlign: 'left',
  },
  paragraph: {
    fontSize: '0.7rem',
    lineHeight: 1.7,
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
  rightJustified: {
    fontSize: '0.7rem',
    lineHeight: 1.7,
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
    textAlign: 'right',
  },
  sectionHeader: {
    fontWeight: 600,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    fontSize: '1rem',
  },
  submitButton: {
    color: '#fff',
    backgroundColor: theme.palette.primary.main,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    width: '25%',
  },
}));

interface Props {
  signatureRef: React.RefObject<SignatureFieldHandle>;
  loan: any;
  handleSubmit: any;
}

export const AssignmentAndConveyanceContentPage = observer(({ signatureRef, loan, handleSubmit }: Props) => {
  const classes = useStyles();
  const { globalStore } = useBaseStore();

  const expectedClosingDate = loan?.expectedClosingDate;
  const companyName = globalStore.lenderInfo?.companyName;
  const agreementDate = globalStore.lenderInfo?.agreementDate;

  return (
    <>
    <Box className={classes.container}>
      <Typography className={classes.title}>
        ASSIGNMENT & CONVEYANCE
      </Typography>

      <Typography className={classes.paragraph}>
        On this: <b>{expectedClosingDate}, {companyName}</b> (the "Seller"), under that certain Master Loan Purchase and Sale
        Agreement, dated as of {agreementDate} (the “Agreement”), does hereby sell, transfer, assign, set over and convey to
        LOAN FUNDER LLC, as buyer (the “Buyer”), under the Agreement, without recourse, all rights, title, and interest
        of the Seller in and to the Purchased Loan(s) listed on the Schedule of Purchased Loans attached hereto as Annex A,
        including, without limitation, all Loan Documents and all other agreements, certificates, or other documents now or
        hereafter evidencing, guaranteeing, securing, or otherwise executed in connection with such Purchased Loan(s).
      </Typography>

      <Typography className={classes.paragraph}>
        The Seller confirms to the Buyer that the representation and warranties set forth in Sections 6 and 7 of the
        Agreement are true and correct with respect to the Seller and the Purchased Loan(s) listed on the Schedule of
        Underlying Loans attached hereto as of the date hereof.
      </Typography>

      <Typography className={classes.paragraph}>
        The ownership of each Purchased Loan is vested in the Buyer.
      </Typography>

      <Typography className={classes.paragraph}>
        Capitalized terms used herein and not otherwise defined shall have the meanings set forth in the Agreement.
      </Typography>

      <Typography className={classes.paragraph}>
        IN WITNESS WHEREOF, the Seller has caused its name to be signed hereto by its respective officer thereunto
        authorized as of the date first above written.
      </Typography>

      <Typography className={classes.paragraph}>
        SELLER:
        <br/>
        <b>{companyName}</b>
      </Typography>

      <SignatureField ref={signatureRef} penColor="green" />
    </Box>
    {isTpoWithMersLoan(loan) && (
      <Box maxWidth={1000} mx="auto" mt={4}>
        <WetSignRequiredNotice />
      </Box>
    )}
    <Grid container style={{ justifyContent: 'center' }}>
      <Button
        variant="contained"
        className={classes.submitButton}
        onClick={handleSubmit}
      >
        SUBMIT
      </Button>
    </Grid>
    </>
  );
});